import React from "react";

// Kampus Campanion brand logo + wordmark
// Accepts size variants and an optional dark mode (for dark backgrounds).
const BrandLogo = ({ size = "md", wordmark = true, sub = true, dark = false, className = "" }) => {
  const dimensions = {
    sm: { logo: "w-10 h-10", brandText: "text-base", subText: "text-[10px]" },
    md: { logo: "w-12 h-12 sm:w-16 sm:h-16", brandText: "text-base sm:text-lg", subText: "text-[9px] sm:text-[11px]" },
    lg: { logo: "w-16 h-16 sm:w-24 sm:h-24", brandText: "text-2xl sm:text-3xl", subText: "text-xs sm:text-sm" },
  }[size];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/assets/kampus-logo.svg"
        alt="Kampus Campanion"
        className={`${dimensions.logo} object-contain flex-shrink-0`}
      />
      {wordmark && (
        <div className="flex flex-col leading-tight">
          <span className={`font-heading font-bold ${dimensions.brandText} ${dark ? "text-white" : "text-slate-900"}`}>
            Kampus Campanion
          </span>
          {sub && (
            <span className={`${dimensions.subText} uppercase tracking-widest font-semibold ${dark ? "text-blue-300" : "text-blue-600"}`}>
              Internship Platform
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default BrandLogo;

